(function () {
  function nextUrl(root) {
    var link = root.querySelector(".valen-pagination-source a[href][aria-label*='Next'], .valen-pagination-source a[href][aria-label*='successiva'], .valen-pagination-source a[href][aria-label*='Successiva']");
    if (link) return link.getAttribute("href");

    var arrows = root.querySelectorAll(".valen-pagination-source a[href].pagination__item-arrow");
    return arrows.length ? arrows[arrows.length - 1].getAttribute("href") : null;
  }

  function absolute(url) {
    return new URL(url, window.location.href).toString();
  }

  async function loadNext(root) {
    var grid = root.querySelector("#product-grid[data-valen-autoload='true']");
    if (!grid || grid.dataset.valenLoadingNext === "true") return;

    var seen = new Set(
      Array.prototype.map.call(grid.querySelectorAll("[data-valen-id]"), function (node) {
        return node.getAttribute("data-valen-id");
      }),
    );
    var url = nextUrl(root);
    if (!url) return;

    grid.dataset.valenLoadingNext = "true";
    try {
      var res = await fetch(absolute(url), { credentials: "same-origin" });
      if (!res.ok) return;

      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, "text/html");
      var nextRoot = doc.querySelector("#valen-shelf");
      var nextGrid = nextRoot && nextRoot.querySelector("#product-grid");
      if (!nextRoot || !nextGrid) return;

      Array.prototype.forEach.call(nextGrid.children, function (item) {
        // The continuation divider is rendered on every paginated page (see
        // valen-shelf.liquid) so each page is valid on its own; the one
        // already in this page's grid is the single source of truth that
        // theme-chat.tsx (continuationMarker) manages, so later pages' own
        // copies must never be imported here or they'd duplicate it.
        if (item.hasAttribute("data-valen-continuation")) return;
        var id = item.getAttribute("data-valen-id");
        if (id && seen.has(id)) return;
        if (id) seen.add(id);
        if (grid.dataset.valenReconciled === "true") item.style.order = String(grid.children.length);
        grid.appendChild(document.importNode(item, true));
      });

      var source = root.querySelector(".valen-pagination-source");
      if (source) source.innerHTML = "";
      var nextSource = nextRoot.querySelector(".valen-pagination-source");
      if (source && nextSource) source.innerHTML = nextSource.innerHTML;
      else if (source) source.remove();

      document.dispatchEvent(new CustomEvent("valen:shelf-page-loaded", { detail: { count: seen.size } }));
    } finally {
      grid.dataset.valenLoadingNext = "false";
    }
  }

  function watch(root) {
    var grid = root.querySelector("#product-grid[data-valen-autoload='true']");
    if (!grid || grid.dataset.valenWatching === "true") return;

    var sentinel = document.createElement("div");
    sentinel.className = "valen-shelf-sentinel";
    sentinel.setAttribute("aria-hidden", "true");
    grid.insertAdjacentElement("afterend", sentinel);
    grid.dataset.valenWatching = "true";

    var loadIfNear = function () {
      if (!document.body.contains(sentinel)) return;
      if (!nextUrl(root)) {
        sentinel.remove();
        window.removeEventListener("scroll", loadIfNear);
        window.removeEventListener("resize", loadIfNear);
        return;
      }
      if (sentinel.getBoundingClientRect().top <= window.innerHeight + 900) {
        loadNext(root).catch(function () {});
      }
    };

    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting; })) {
            loadNext(root).catch(function () {});
          }
          if (!nextUrl(root)) {
            observer.disconnect();
            sentinel.remove();
          }
        },
        { rootMargin: "900px 0px" },
      );
      observer.observe(sentinel);
      return;
    }

    loadIfNear();
    window.addEventListener("scroll", loadIfNear, { passive: true });
    window.addEventListener("resize", loadIfNear, { passive: true });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll("#valen-shelf"), function (root) {
      watch(root);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  // Dawn's facets.js swaps the whole #ProductGridContainer when a filter changes, which drops the sentinel
  // and the grid we were watching: watch the new grid too. No container (home, no facets) = nothing to do.
  function observeFacetSwaps() {
    var container = document.getElementById("ProductGridContainer");
    if (container && "MutationObserver" in window) {
      new MutationObserver(boot).observe(container, { childList: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observeFacetSwaps, { once: true });
  } else {
    observeFacetSwaps();
  }
})();
